module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/_library.js
 ** module id = 60
 ** module chunks = 0
 **/